import { getRoot } from "mobx-state-tree"

export const locationsFactoryViews = self => ({

})